'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Heading, Skeleton } from '@nutralab/ui';

import { classNames } from '@m1work/shared-utils';

import styles from './ReviewsSkeleton.module.scss';

/** The reviews page while it loads: the heading and two review cards, like ReviewBlock. */
export function ReviewsSkeleton(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <div aria-busy="true" className={styles.page}>
            <Container>
                <Skeleton asChild>
                    <Heading level={2} className="mb-20" size="2xl" align="center" weight="semibold">
                        {t('landing.reviews.title')}
                    </Heading>
                </Skeleton>

                <div className={classNames(styles.cards, 'mx-12')}>
                    <Skeleton className={styles.card} />
                    <Skeleton className={classNames(styles.card, styles['second-card'])} />
                </div>
            </Container>
        </div>
    );
}
